import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';

import { useCommentsRoot } from '../Root';

import COMMENT from 'constants/comment';

const SORT_LABELS = {
  BY_OLDER: 'Mais antigos',
  BY_LATEST: 'Mais recentes',
  BY_RELEVANCE: 'Mais relevantes',
};

/*
  Variante icon-only do `Sort` — usada dentro do `TabNav` da página
  de oferta, pra liberar a linha inteira acima da lista (que antes
  ficava só pra mostrar o select "Mais relevantes"). Por baixo segue
  um `<select>` nativo (invisível e sobreposto ao ícone), então a UX
  de seleção continua familiar em mobile/desktop sem precisar de
  dropdown custom.
*/
const IconSort = () => {
  const { commentsSort, gaEventCategory, setCommentsSort } = useCommentsRoot();

  const onChange = ({ target }) => {
    const sort = target.value;

    sendEvent({
      action: `sort_comment_${sort}`,
      category: gaEventCategory,
    });
    setCommentsSort(sort);
  };

  return (
    <div
      className="relative inline-flex size-8 items-center justify-center"
      title="Ordenar comentários"
    >
      <Icon
        className="pointer-events-none text-neutral-low-300 dark:text-neutral-high-200"
        name="list"
        size="size3"
        aria-hidden
      />
      <select
        aria-label="Ordenar comentários"
        className="absolute inset-0 cursor-pointer appearance-none bg-transparent opacity-0"
        value={commentsSort}
        onChange={onChange}
      >
        <option value={COMMENT.SORT_VALUES.RELEVANCE}>
          {SORT_LABELS.BY_RELEVANCE}
        </option>
        <option value={COMMENT.SORT_VALUES.LATEST}>
          {SORT_LABELS.BY_LATEST}
        </option>
        <option value={COMMENT.SORT_VALUES.OLDEST}>
          {SORT_LABELS.BY_OLDER}
        </option>
      </select>
    </div>
  );
};

export default IconSort;
